module.exports = __webpack_public_path__ + "img/IntermediateGroups.9e00424e.webp";